import React from 'react'
import Svg from '../../../../packages/uikit/src/components/Svg/Svg'
import { SvgProps } from '../../../../packages/uikit/src/components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => (
  <Svg width="22" height="15" viewBox="0 0 22 15" fill="none" {...props}>
    <path
      d="M22.0005 7.67333C20.614 10.6148 18.436 12.7012 15.444 13.8755C9.75757 16.1101 3.24035 13.4707 0.590797 7.88995C0.461687 7.61632 0.472914 7.3655 0.607637 7.09757C2.42078 3.49485 5.28926 1.27736 9.19623 0.530592C14.355 -0.455595 19.6316 2.32055 21.8995 7.13178C21.9332 7.20018 21.9668 7.26859 22.0005 7.337C22.0005 7.44531 22.0005 7.55932 22.0005 7.67333ZM11.2395 3.18133C8.88749 3.18133 6.98452 5.1195 6.98452 7.50801C6.98452 9.89652 8.89871 11.8347 11.2451 11.829C13.5972 11.829 15.5001 9.88512 15.5001 7.50231C15.5001 5.1138 13.5916 3.17563 11.2395 3.18133Z"
      fill="black"
    />
    <path
      d="M11.2454 10.3691C9.67929 10.3691 8.42188 9.09223 8.42188 7.49609C8.42749 5.91135 9.67929 4.64014 11.2398 4.64014C12.806 4.64014 14.0634 5.91705 14.0634 7.51319C14.0578 9.09793 12.806 10.3691 11.2454 10.3691Z"
      fill="black"
    />
  </Svg>
)

export default Icon
